import React, { FC } from 'react'
import { t, Trans } from '@lingui/macro'

import { PathwayProgressStatus } from 'front-end/src/graphql/private/PrivateSchemaTypes'

import { AccessibilityLabel } from '../../../../components/common/AccessibilityLabel'
import { Box, Select } from 'front-end/src/components'

export interface IProps {
  progress: PathwayProgressStatus
  onProgressChange: (state: PathwayProgressStatus) => void
}

const selectOptions = [
  {
    value: PathwayProgressStatus.ALL,
    label: <Trans>All</Trans>
  },
  {
    value: PathwayProgressStatus.NOT_STARTED,
    label: <Trans>Not started</Trans>
  },
  {
    value: PathwayProgressStatus.IN_PROGRESS,
    label: <Trans>In progress</Trans>
  },
  {
    value: PathwayProgressStatus.FAILED,
    label: <Trans>Failed</Trans>
  },
  {
    value: PathwayProgressStatus.COMPLETED,
    label: <Trans>Completed</Trans>
  },
  {
    value: PathwayProgressStatus.OVERDUE,
    label: <Trans>Overdue</Trans>
  }
]

const PathwaysFilters: FC<IProps> = (props: IProps) => {
  const { progress, onProgressChange } = props

  return (
    <Box marginX="8px">
      <AccessibilityLabel text={t`Progress`}>
        <Select
          options={selectOptions}
          value={selectOptions.find(({ value }) => {
            return value === progress
          })}
          onChange={(v) => onProgressChange(v?.value)}
        />
      </AccessibilityLabel>
    </Box>
  )
}

export default PathwaysFilters
